module.exports = __webpack_public_path__ + "static/media/logo.00c56b27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 318
// module chunks = 0